import {Link} from '@salt-ds/core';
import Constants from '../components/common/Constants';
import React from 'react';

export const formatCardNumber = formattedValue => {
  return formattedValue
    .match(/.{1,4}/g)
    ?.join('-')
    .slice(0, 19) || '';
};

export const formatBillingZipCode = formattedValue => {
  formattedValue = formattedValue.replace(/\s+/g, '').toUpperCase();

  const canadianPostalCodeRegex = /^[A-Z]\d[A-Z]\d[A-Z]\d$/;

  if (canadianPostalCodeRegex.test(formattedValue)) {
    // Format as A0A 0A0
    return formattedValue.slice(0, 3) + ' ' + formattedValue.slice(3, 6);
  } else {
      return formattedValue.slice(0,9);
  }
}

export const formatPhoneNumber = formattedValue => {
  // Format as 000-000-0000
  if (formattedValue.length > 6) {
    formattedValue = formattedValue.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3');
  } else if (formattedValue.length > 3) {
    formattedValue = formattedValue.replace(/(\d{3})(\d{0,3})/, '$1-$2');
  }
  formattedValue = formattedValue.slice(0, 12);
  return formattedValue;
}

export const maskedEmailAddress = (email) => {
  const [username, domain] = email.split('@');
  const maskedUsername = username.length > 2 ? username.charAt(0) + '****' + username.charAt(username.length - 1) : username;
  return `${maskedUsername}@${domain}`;
}

export const customerServiceLink = <Link href={"/help/auth/Log_In_Portal/Log_In_Screen/Customer_Service.htm"} className="links" IconComponent={null}
  target="_blank">{Constants.customerService}</Link>;

export function isCanadianZipCode(zipCode) {
  // Canadian postal codes are in the format "A1A 1A1"
  const canadianZipCodeRegex = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;
  return canadianZipCodeRegex.test(zipCode);
}